import styled from 'styled-components';

export const Container = styled.div`

`;

export const DatePicker = styled.input`
  display: inline-block;
`;

export const LabelDivider = styled.p`
  display: inline-block;
  margin: 0 1rem;
`;